import { render, staticRenderFns } from "./ErrorMessageBox.vue?vue&type=template&id=d2551d28&scoped=true"
import script from "./ErrorMessageBox.vue?vue&type=script&lang=js"
export * from "./ErrorMessageBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2551d28",
  null
  
)

export default component.exports